import React from 'react';
import { Text, Path } from 'slate';
import { ReactEditor } from 'slate-react';
import { icons } from '@ublend-npm/aulaui-next';
import { AulaPlugin } from '../plugins';
import { latexType } from './latexType';
import { Latex } from '../../components/Latex/Latex';
import { NestedMenuItem } from '../../components/NestedMenu/NestedMenu';
import { AulaEditorInstance } from '../../types';
import { insertBlock } from '../../lib/commands';

export const insertLatex = (editor: AulaEditorInstance, path: Path) => {
  insertBlock(editor, path, [
    {
      type: latexType,
      children: [{ text: '' }],
    },
  ]);
};

export const latex: AulaPlugin = (editableProps, editor) => ({
  ...editableProps,
  blockMenu: {
    ...editableProps.blockMenu,
    Formatting: {
      ...(editableProps.blockMenu || {}).Formatting,
      LaTeX: ({ text, element, attributes, onClose }) => (
        <NestedMenuItem
          leftIcon={<icons.Functions />}
          key={text}
          text={text}
          attributes={{
            ...attributes,
            onClick: () => {
              if (onClose) {
                onClose();
              }
              insertLatex(editor, ReactEditor.findPath(editor, element));
            },
          }}
        />
      ),
    },
  },
  renderElement: (props) => {
    const { children, element, attributes } = props;

    if (element.type === latexType) {
      const {
        children: [text],
      } = element;

      if (Text.isText(text)) {
        const { text: expression } = text;

        return (
          <div {...attributes}>
            <Latex element={element} expression={expression}>
              {children}
            </Latex>
          </div>
        );
      }
    }

    return editableProps.renderElement?.(props) || <p />;
  },
});
